import React from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  CircularProgress,
  FormHelperText,
} from '@mui/material';
import { useLabourItemGroups } from '../hooks/useLabourItemGroups';

interface LabourGroupSelectProps {
  value?: number | null;
  onChange: (groupId: number | null) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
}

export const LabourGroupSelect: React.FC<LabourGroupSelectProps> = ({
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  error = false,
  helperText,
}) => {
  const { data: groups = [], isLoading } = useLabourItemGroups();

  return (
    <FormControl variant="standard" fullWidth={fullWidth} error={error}>
      <Select
        value={value || ''}
        onChange={e => {
          const newValue = e.target.value;
          onChange(newValue ? Number(newValue) : null);
        }}
        disabled={disabled || isLoading}
        sx={{
          selectProps: {
            'data-testid': 'labour-group-select',
          },
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {groups.map(group => (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {isLoading && (
        <CircularProgress
          size={20}
          sx={{
            position: 'absolute',
            right: 30,
            top: '50%',
            marginTop: '-10px',
          }}
        />
      )}
    </FormControl>
  );
};
